import { atom } from 'recoil';

export const profileAtom = atom({
  key: 'profileAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});